import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { User } from "./user"

Vue.use(Vuex);

export default new Vuex.Store<StoreOptions<{}>>({
  modules: { User }
});
